/**
 *
 * Asynchronously loads the component for AlertWorkflow
 *
 */

import { lazyLoad } from 'utils/loadable';

export const AlertWorkflow = lazyLoad(
  // @ts-ignore
  () => import('./index.tsx'),
  module => module.AlertWorkflow,
);
